import styled from '@emotion/styled';
import { StyledContentContainer, StyledContainer } from '@selfserve/react-ui';

export const StyledPurchasePlanContainer = styled(StyledContentContainer)(
  ({ theme }: { theme?: any }) => ({
    marginTop: '40px',
    [theme.breakpoints.up('lg')]: {
      padding: '0 120px',
    },
  })
);

export const StyledPurchasePlanContentContainer = styled(StyledContainer)(
  ({ theme }: { theme?: any }) => ({
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  })
);

export const StyledFormContainer = styled(StyledContainer, {
  shouldForwardProp: (prop) => {
    return prop !== 'withoutMargin';
  },
})(({ theme, withoutMargin }: { theme?: any; withoutMargin?: boolean }) => ({
  flex: 1,
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up('md')]: {
    marginRight: theme.spacing(4),
    marginBottom: 0,
  },
  ...(!withoutMargin && {
    '> div': {
      marginBottom: '32px',
    },
  }),
}));

export const StyledSummaryContainer = styled.div(
  ({ theme }: { theme?: any }) => ({
    flex: '0 0 380px',
    [theme.breakpoints.down('lg')]: {
      flexBasis: '304px',
    },
    [theme.breakpoints.down('md')]: {
      flexBasis: 'initial',
    },
  })
);
